/**
 * @fileoverview GET handler for the "/:app_group_id/operator_mcp_connections/tools" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdOperatorMcpConnectionsTools } from "./constants";
import type {
  GetAppGroupIdOperatorMcpConnectionsToolsProps,
  GetAppGroupIdOperatorMcpConnectionsToolsResult,
} from "./types";
import { isGetAppGroupIdOperatorMcpConnectionsToolsResult } from "./validators";

export const getAppGroupIdOperatorMcpConnectionsTools = reactQueryFetcherAdapter(
  appGroupIdOperatorMcpConnectionsTools,
  (
    signal: AbortSignal,
    { appGroupId, connectionIds }: GetAppGroupIdOperatorMcpConnectionsToolsProps
  ): Promise<GetAppGroupIdOperatorMcpConnectionsToolsResult> => {
    // Listing runs in the background of the page and the drawer, which report a failure themselves.
    return fetch(
      `/${appGroupId}/operator_mcp_connections/tools`,
      "GET",
      connectionIds === undefined ? {} : { connection_ids: connectionIds },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAppGroupIdOperatorMcpConnectionsToolsResult
);
